"use client";
import { Suspense } from "react";
import dynamic from 'next/dynamic';
import useIsMobile from '../../hooks/useIsMobile';
import useTranslations from '../../hooks/useTranslation';

import { useNavbar } from '../../contexts/NavbarContext';
const Loading = dynamic(() => import('../../components/loading/loading'), { suspense: true });
const PrivacyPolicy = dynamic(() => import('./PrivacyPolicy'), { suspense: true });

export default function PrivacyPolicyClient() {
  const isMobile = useIsMobile();
  const { companyRef, productsRef, blogRef, contactusRef, scrollToSection } = useNavbar();
  const {
    loading,
    translations,
    supportedLanguages,
    language,
    selectedLanguage,
    handleLanguageChange,
  } = useTranslations();

  return (
    <>
      <div>
        <PrivacyPolicy isMobile={isMobile} language={language}
          translations={translations} />
      </div>
    </>
  );
}